import { getClassifiedAs, normalizeFieldToArray } from "@thegetty/linkedart.js";
import { getName } from "@thegetty-private/linked-data.js";
import aat from "@/data/aat.json";
import ulan from "@/data/ulan.json";

const CONTACT_POINT = "contact_point";
const EXACT_MATCH = "exact_match";
const SUBJECT_OF = "subject_of";

/**
 * Checks whether a group is associated with the Getty ULAN IDs
 *
 * @param {Object} group - the JSON-LD representation of the actor
 *
 * @returns {boolean} (yes, if the group is a getty group)
 */
export function isGroupTheGetty(group) {
  let groupIds = normalizeFieldToArray(group, EXACT_MATCH).filter((item) =>
    [
      ulan.GETTY_CENTER,
      ulan.GETTY_RESEARCH_INSTITUTE,
      ulan.GETTY_VILLA,
      ulan.GETTY
    ].includes(item.id)
  );
  if (groupIds.length > 0) {
    return true;
  }
  return false;
}

/**
 * Gets the department's homepage from the LOD group record
 *
 * @param {Object} group - the JSON-LD representation of the group
 * @returns {String} - the department's homepage
 */
function getDepartmentUrl(group) {
  let url;
  const subjectOf = normalizeFieldToArray(group, SUBJECT_OF);
  const deptLink = getClassifiedAs(subjectOf, aat.WEB_PAGES);
  if (deptLink[0]) {
    url = deptLink[0].id;
  }
  return url;
}

/**
 * Gets the department's contact e-mail from the LOD group record
 *
 * @param {Object} group - the JSON-LD representation of the group
 * @returns {String} - the department's contact email (default to email@getty.edu)
 */

function getDepartmentContact(group) {
  let contact = "email@getty.edu";
  const contactPoint = normalizeFieldToArray(group, CONTACT_POINT);
  const deptContact = getClassifiedAs(contactPoint, aat.EMAIL_ADDRESSES);
  if (deptContact[0] && deptContact[0].content) {
    contact = deptContact[0].content;
  }
  return contact;
}

/**
 * Gets a department's name, contact, and url from the LOD group record
 *
 * @param {Object} group - the JSON-LD representation of the group
 * @returns {Object} - an object containing the name, url, and contact e-mail of the department
 */

export function getDepartmentInfo(group) {
  return {
    deptName: getName(group),
    email: getDepartmentContact(group),
    url: getDepartmentUrl(group)
  };
}
